var map = {
	"./cases_ident_visual_fiat_01.jpg": 107,
	"./cases_ident_visual_fiat_02.jpg": 108,
	"./cases_ident_visual_fiat_03.jpg": 109,
	"./cases_ident_visual_fiat_04.jpg": 110
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 315;